import { Store } from 'redux';

import {
  HttpInterceptor,
  HttpResponseCodeBoltServer,
  HttpResponseUtilsBoltServer,
} from '@bolteu/http-client-bolt-server';
import { logoutAsync } from '@bolteu/redux-session';

// log out the user if a network request returns a NOT_AUTHORIZED response from the server, but not if the error is due to an expired JWT token or missing permissions
export function createAuthInvalidatedInterceptor(store: Store): HttpInterceptor {
  return {
    async intercept(req, next) {
      const response = await next(req);

      if (
        HttpResponseUtilsBoltServer.isBoltServerResponse(response) &&
        response.body.code === HttpResponseCodeBoltServer.NOT_AUTHORIZED &&
        !HttpResponseUtilsBoltServer.isJwtTokenExpiredError(response) &&
        !HttpResponseUtilsBoltServer.isMissingPermissionsError(response) &&
        !HttpResponseUtilsBoltServer.isLegacyMissingPermissionsError(response)
      ) {
        store.dispatch(logoutAsync.success());
      }

      return response;
    },
  };
}
